import { z } from 'zod';
import { strictRemoteCodec } from "./remote-codec.js";
import { SessionContinuationViewSchema, ContinuationDefaultViewSchema } from "./session-continuation-types.js";
const contribution = {
    package: 'dsh-github-copilot',
    descriptors: ['get', 'set', 'authorizeNext', 'defaults', 'setDefault'].map(method => ({
        id: `dsh-github-copilot:githubCopilotSessionContinuation.${method}`,
        namespace: 'githubCopilotSessionContinuation', service: 'githubCopilotSessionContinuation', method,
        invocation: { kind: 'direct' },
        parameters: [
            ...method === 'defaults' || method === 'setDefault' ? [] : [
                { name: 'agent', wire: 'agentId', source: 'lookup', lookup: 'agent',
                    codec: strictRemoteCodec('@deepseek-ai/dsh-session/types#SessionId', z.string().min(1).max(256)) }
            ],
            ...method === 'set' || method === 'authorizeNext' || method === 'setDefault' ? [
                { name: 'revision', wire: 'revision', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#SessionContinuationRevision', z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER)) },
                { name: 'enabled', wire: 'enabled', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#SessionContinuationEnabled', method === 'set' ? z.boolean().nullable() : z.boolean()) },
            ] : [],
        ],
        result: method === 'defaults' || method === 'setDefault'
            ? strictRemoteCodec('dsh-github-copilot#ContinuationDefaultView', ContinuationDefaultViewSchema)
            : strictRemoteCodec('dsh-github-copilot#SessionContinuationView', SessionContinuationViewSchema),
    })),
};
export default contribution;
//# sourceMappingURL=session-continuation-remote.js.map